import { Link } from 'react-router-dom'

/**
 * Today's three quests.
 *
 * The point of this panel is to answer "what should I do right now?" without
 * the player having to decide. A returning user who has to choose is a
 * returning user who might not.
 */

export interface QuestState {
  id: string
  kind: 'learn' | 'prove' | 'build'
  title: string
  xp: number
  gems: number
  progress: number
  target: number
  completed: boolean
}

const KIND_ICON: Record<QuestState['kind'], string> = {
  learn: '📖',
  prove: '⚔',
  build: '🔧',
}

export default function QuestPanel({
  quests,
  patrolAvailable,
}: {
  quests: QuestState[]
  patrolAvailable?: number
}) {
  const done = quests.filter((q) => q.completed).length

  return (
    <section className="quest-panel">
      <h2 className="quest-heading">
        Today's quests <span className="dim">{done}/{quests.length}</span>
      </h2>

      <ul className="quest-list">
        {quests.map((q) => (
          <li key={q.id} className={q.completed ? 'quest quest-done' : 'quest'}>
            <span className="quest-icon" aria-hidden="true">
              {q.completed ? '✅' : KIND_ICON[q.kind]}
            </span>
            <div className="quest-body">
              <span className="quest-title">{q.title}</span>
              <div className="progress-track quest-track">
                <div
                  className="progress-fill"
                  style={{ width: `${Math.round((q.progress / q.target) * 100)}%` }}
                />
              </div>
            </div>
            <span className="quest-reward dim">
              {q.progress}/{q.target} · {q.xp} XP · {q.gems}💎
            </span>
          </li>
        ))}
      </ul>

      {patrolAvailable !== undefined && patrolAvailable > 0 && (
        <Link to="/patrol" className="patrol-cta">
          🛡 <strong>{patrolAvailable} question{patrolAvailable === 1 ? '' : 's'} due on patrol</strong>
          <span className="dim"> — the highest XP per minute in the game, and not by accident</span>
        </Link>
      )}
    </section>
  )
}
